/**
 * "Jela" za firme sa ugovorom "više restorana" (telefon i računar): redovi starog taba (rows) grupisani po grupi
 * jela, sa zbirom po grupi; grupe se mogu sklopiti. Zahteva nasleđen stari tab
 * more-restaurants/tabs/ReportMealsTabDishes (rows). Grupe idu redom kojim stižu (stari tab ih već sortira).
 */
export default {
  data: () => ({
    collapsed: {},
  }),
  computed: {
    sections() {
      const sections = [];
      const byKey = {};
      this.rows.forEach((row) => {
        const key = String(row.group);
        if (!byKey[key]) {
          byKey[key] = { key, name: this.toLatin(String(row.group)), rows: [], total: 0 };
          sections.push(byKey[key]);
        }
        byKey[key].rows.push({
          ...row,
          label: this.toLatin(row.name || ""),
          title: `${this.toLatin(row.name || "")}${row.id != null ? ` · ID ${row.id}` : ""}`,
        });
        byKey[key].total += row.total;
      });
      return sections;
    },
    emptyTitle() {
      return this.filters.search
        ? this.$t("report_mobile.no_results_for", { search: this.filters.search })
        : this.$t("no_meals_for_selected_period");
    },
  },
  methods: {
    toggle(key) {
      this.$set(this.collapsed, key, !this.collapsed[key]);
    },
  },
};
